<template>
    <div>
        <div class="mt40">
            <el-checkbox @change="emitChecked" v-model="agreement">
                <span class="g6">我已阅读，理解并接受</span>
            </el-checkbox>
            <span class="green poi" @click="openSp">《中企动力域名注册服务协议》</span>
            <span class="green poi" @click="openCp">《中企域名高级服务协议》</span>
        </div>
        <online-service-protocol :visible.sync="SpVisible" @close="CloseSp"></online-service-protocol>
        <advanced-domain-register-service-protocol :visible.sync="CpVisible" @close="CloseCp"></advanced-domain-register-service-protocol>
    </div>
</template>
<script>
import OnlineServiceProtocol from './protocol/OnlineServiceProtocol'
import advancedDomainRegisterServiceProtocol from './protocol/advancedDomainRegisterServiceProtocol'

export default {
    name: 'protocol',
    data() {
        return {
            agreement: this.acceptAgreement,
            SpVisible: false,
            CpVisible: false
        }
    },
    props: ['acceptAgreement'],
    components: {
        OnlineServiceProtocol,
        advancedDomainRegisterServiceProtocol
    },
    methods: {
        emitChecked(){
            this.$emit('input', this.agreement)
        },
        openSp() {
            this.SpVisible = true
        },
        CloseSp() {
            this.SpVisible = false
        },
        openCp() {
            this.CpVisible = true
        },
        CloseCp() {
            this.CpVisible = false
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Protocol-domain.vue